/* =============================================================
   JMM Zone d'intervention — sélection d'agence (zoom carte,
   cascade des villes couvertes triées par distance), zoom
   libre boutons + molette, pin mystère qui se téléporte.
   Délégation d'événements (résiste aux re-rendus de l'éditeur),
   multi-instances, ré-init via shopify:section:load.
   ============================================================= */
(function () {
  'use strict';

  function up(el, attr, stop) {
    while (el && el !== stop) {
      if (el.getAttribute && el.hasAttribute(attr)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function initJmz(root) {
    if (root.getAttribute('data-jmz-init') === '1') return;
    root.setAttribute('data-jmz-init', '1');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var map = root.querySelector('[data-jmz-map]');
    var wrap = root.querySelector('.jmz__mapwrap');
    if (!map || !wrap) return;

    var focusZoom = parseFloat(root.getAttribute('data-jmz-zoom')) || 1.35;
    var outZoom = parseFloat(root.getAttribute('data-jmz-outzoom')) || 0.9;
    var scale = 1;
    var timers = [];

    function apply() { map.style.transform = 'scale(' + scale + ')'; }

    function zoom(d) {
      scale = Math.max(.75, Math.min(2.2, Math.round((scale + d) * 100) / 100));
      apply();
    }

    function fit(card, open) {
      var m = card.querySelector('.jmz__more');
      if (m) m.style.maxHeight = open ? m.scrollHeight + 'px' : '0px';
    }

    function all(s) { return [].slice.call(root.querySelectorAll(s)); }

    function sel(id) {
      timers.forEach(clearTimeout); timers = [];
      all('.jmz__ct').forEach(function (v) { v.classList.remove('is-lit'); });
      all('[data-jmz-card]').forEach(function (c) { var on = c.getAttribute('data-jmz-card') === id; c.classList.toggle('is-on', on); fit(c, on); });
      all('[data-jmz-pin]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-jmz-pin') === id); });
      all('[data-jmz-zone]').forEach(function (z) { z.classList.toggle('is-on', z.getAttribute('data-jmz-zone') === id); });
      all('[data-jmz-spokes]').forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-jmz-spokes') === id); });

      if (id === 'myst') {
        scale = outZoom;
        map.style.transformOrigin = '50% 50%';
        apply();
        return;
      }

      var pin = root.querySelector('[data-jmz-pin="' + id + '"]');
      if (!pin) return;
      var px = parseFloat(pin.getAttribute('data-x'));
      var py = parseFloat(pin.getAttribute('data-y'));
      map.style.transformOrigin = px + '% ' + py + '%';
      scale = focusZoom;
      apply();

      var cov = all('.jmz__ct').filter(function (v) {
        return (' ' + (v.getAttribute('data-cov') || '') + ' ').indexOf(' ' + id + ' ') > -1;
      });
      cov.sort(function (a, b) {
        function d(v) {
          var dx = parseFloat(v.getAttribute('data-x')) - px;
          var dy = parseFloat(v.getAttribute('data-y')) - py;
          return dx * dx + dy * dy;
        }
        return d(a) - d(b);
      });
      cov.forEach(function (v, i) {
        timers.push(window.setTimeout(function () { v.classList.add('is-lit'); }, reduce ? 0 : 400 + i * 100));
      });
    }

    root.addEventListener('click', function (e) {
      var zbtn = up(e.target, 'data-jmz-z', root);
      if (zbtn) { zoom(parseFloat(zbtn.getAttribute('data-jmz-z')) * .25); return; }
      if (up(e.target, 'href', root)) return;
      var pin = up(e.target, 'data-jmz-pin', root);
      if (pin) { sel(pin.getAttribute('data-jmz-pin')); return; }
      var card = up(e.target, 'data-jmz-card', root);
      if (card) sel(card.getAttribute('data-jmz-card'));
    });

    wrap.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoom(e.deltaY < 0 ? .15 : -.15);
    }, { passive: false });

    var myst = root.querySelector('.jmz__pin--myst');
    if (myst && !reduce) {
      var spots = (root.getAttribute('data-jmz-spots') || '30,24;67,79;27,81;69,21').split(';').map(function (s) {
        var p = s.split(',');
        return [parseFloat(p[0]) * 5, parseFloat(p[1]) * 4];
      });
      var si = 0;
      var place = function () { myst.setAttribute('transform', 'translate(' + spots[si][0] + ',' + spots[si][1] + ')'); };
      place();
      window.setInterval(function () {
        myst.style.opacity = '0';
        window.setTimeout(function () {
          si = (si + 1) % spots.length;
          place();
          myst.style.opacity = '1';
        }, 380);
      }, 3600);
    }

    var firstCard = root.querySelector('[data-jmz-card]');
    if (firstCard) sel(firstCard.getAttribute('data-jmz-card'));
  }

  function initAll() { document.querySelectorAll('[data-jmz]').forEach(initJmz); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
